import React from 'react';
import { Card, Placeholder } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export const OrderFormSkeleton = () => {
  return (
    <Card className="shadow m-a" border={undefined} bg="light">
      <Card.Header>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ flex: 1 }}>
            <Skeleton height={20} width="60%" />
          </div>
          <Skeleton height={20} width={90} />
        </div>
      </Card.Header>
      <Card.Body>
        <div style={{ marginBottom: 12 }}>
          <Skeleton height={16} width="35%" />
          <Skeleton height={38} style={{ marginTop: 6 }} />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
          <div>
            <Skeleton height={14} width="55%" />
            <Skeleton height={38} style={{ marginTop: 6 }} />
          </div>
          <div>
            <Skeleton height={14} width="55%" />
            <Skeleton height={38} style={{ marginTop: 6 }} />
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
          <div>
            <Skeleton height={14} width="55%" />
            <Skeleton height={38} style={{ marginTop: 6 }} />
          </div>
          <div>
            <Skeleton height={14} width="55%" />
            <Skeleton height={38} style={{ marginTop: 6 }} />
          </div>
        </div>

        <div style={{ marginTop: 18, marginBottom: 8 }}>
          <Skeleton height={16} width="40%" />
        </div>
        <Skeleton height={120} />
      </Card.Body>

      <Card.Footer style={{ padding: '0.75rem 0.9rem' }}>
        <div style={{ display: 'flex', gap: 10 }}>
          <Skeleton height={36} width={110} />
          <Skeleton height={36} width={110} />
        </div>
        <Placeholder className="mt-2" xs={12} />
      </Card.Footer>
    </Card>
  );
};

